(function() {
  function initSolutionFeatures(section) {
    if (!section) return;

    var tabs = section.querySelectorAll('.solution-features-2026__tab');
    var panels = section.querySelectorAll('.solution-features-2026__panel');

    if (!tabs.length || !panels.length) return;

    function activateTab(tab) {
      var target = tab.getAttribute('data-target');

      tabs.forEach(function(item) {
        var active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.setAttribute('tabindex', active ? '0' : '-1');
      });

      panels.forEach(function(panel) {
        var isTarget = panel.id === target;
        panel.classList.toggle('is-active', isTarget);
        if (isTarget) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', 'hidden');
        }
      });
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        activateTab(tab);
      });

      tab.addEventListener('keydown', function(event) {
        var currentIndex = Array.prototype.indexOf.call(tabs, tab);
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          var next = tabs[(currentIndex + 1) % tabs.length];
          next.focus();
          activateTab(next);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          var prev = tabs[(currentIndex - 1 + tabs.length) % tabs.length];
          prev.focus();
          activateTab(prev);
        }
      });
    });
  }

  document.addEventListener('shopify:section:load', function(e) {
    initSolutionFeatures(e.detail.section);
  });

  document.addEventListener('DOMContentLoaded', function() {
    var sections = document.querySelectorAll('.solution-features-2026');
    sections.forEach(initSolutionFeatures);
  });
})();
